import React from 'react';
import { Button } from 'antd';
import './Button.scss';

const CustomButton = ({ children, onClick, size, type, htmlType, color, variant, shape, icon, iconPosition, block, disabled, loading, style, className }) => {
    return (
        <Button
            type={type}
            size={size}
            htmlType={htmlType}
            onClick={onClick}
            color={color}
            variant={variant}
            shape={shape}
            icon={icon}
            iconPosition={iconPosition}
            block={block}
            disabled={disabled}
            loading={loading}
            style={style}
            className={className}
        >
            {children}
        </Button>
    );
};

export default CustomButton;
